// extracted by mini-css-extract-plugin
module.exports = {"optionRow":"AutobookRuleOptionLabel_optionRow__1U2rj","labelText":"AutobookRuleOptionLabel_labelText__ie2lQ"};